module.exports = __webpack_public_path__ + "static/media/by.52e224c1.svg";